import { useEffect } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import PasswordForm from "@/components/auth/PasswordForm";

/** Account menu → Change password. Signs out the person's other devices (the server ends older sessions). */
export default function ChangePasswordDialog({ onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div role="dialog" aria-modal="true" aria-labelledby="change-pw-title" onClick={(e) => e.stopPropagation()}
           className="w-full max-w-md bg-[var(--surface)] rounded-xl border border-[var(--border)] p-5 sm:p-6" data-testid="change-password">
        <div className="flex items-center justify-between mb-1">
          <h2 id="change-pw-title" className="font-heading text-lg font-semibold">Change password</h2>
          <button type="button" onClick={onClose} aria-label="Close" className="p-1.5 rounded-md hover:bg-[var(--surface-hover)]"><X size={16} /></button>
        </div>
        <p className="text-xs text-[var(--ink-3)] mb-5">Your other phones and computers will be signed out.</p>
        <PasswordForm askCurrent submitLabel="Change password" onDone={() => { toast.success("Password changed"); onClose(); }} />
      </div>
    </div>
  );
}
